var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBundled = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 398.98 356.672"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 28",
  d: "M334.088 149.488a14.986 14.986 0 01-14.971-15V50.594a14.971 14.971 0 1129.942 0v83.894a14.986 14.986 0 01-14.971 15z",
  fill: "#ed6c7b"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 29",
  d: "M34.65 354.038v-197.4a5.006 5.006 0 011.679-3.74L195.679 11.26a4.982 4.982 0 016.623 0l159.35 141.635a5.008 5.008 0 011.679 3.74v197.403H34.65z",
  fill: "#cdebfc"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 30",
  d: "M361.653 152.895L202.303 11.26a4.983 4.983 0 00-3.312-1.26v344.038h164.341v-197.4a5.008 5.008 0 00-1.679-3.743z",
  fill: "#bfe1fd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 34",
  d: "M383.006 193.562a14.888 14.888 0 01-9.929-3.779L198.991 35.052 24.906 189.783a14.988 14.988 0 01-19.869-22.445L189.057 3.776a14.949 14.949 0 0119.869 0l184.02 163.562a15 15 0 01-9.94 26.221z",
  fill: "#ed6c7b"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 35",
  d: "M392.946 167.338L208.926 3.779A14.919 14.919 0 00198.991 0v35.051l174.088 154.731a14.987 14.987 0 0019.87-22.441z",
  fill: "#e20059"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36",
  d: "M387.313 355.038H11.666c-6.443-.19-11.667-6.906-11.667-15.19s5.223-15 11.666-15h375.648c6.443 0 11.666 6.716 11.666 15s-5.223 15-11.666 15.19z",
  fill: "#dafcdb"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 37",
  d: "M387.284 323.848H198.991v30.19h188.292c6.46-.192 11.7-6.908 11.7-15.192s-5.237-15-11.7-15z",
  fill: "#b6fcd1"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "bundled"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2",
  d: "M354.358 226.194l-40.176-12.154-.068-.068-27.61-14.128-13.943-27.895-17.218-17.416a10.27 10.27 0 00-7.273-3.033H104.715a10.216 10.216 0 00-9.113 5.6l-28.3 55.7H55.848a23.884 23.884 0 00-23.857 23.857v17.77l6.816 9.6-6.816 10.849v2.2a37.532 37.532 0 0037.415 37.49h301.359a10.228 10.228 0 0010.226-10.222v-42.262a37.275 37.275 0 00-26.632-35.888z",
  fill: "#ffe478"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3",
  d: "M380.986 262.082v42.262a10.228 10.228 0 01-10.224 10.225H196.866V151.5h51.2a10.27 10.27 0 017.273 3.033l17.218 17.416 13.94 27.893 27.613 14.13.068.068 40.176 12.154a37.275 37.275 0 0126.632 35.888z",
  fill: "#ffca0f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 4",
  d: "M314.115 213.972l-188.971-.348a10.307 10.307 0 01-10.279-10.313l.042-21.157a10.225 10.225 0 0110.224-10.205h147.431z",
  fill: "#91e0fc"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 5",
  d: "M314.115 213.972l-117.249-.223v-41.8h75.7z",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 12",
  d: "M380.99 262.082v11.833h-33.4a10.225 10.225 0 010-20.449h32.419a37.86 37.86 0 01.981 8.616z",
  fill: "#ff9803"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 13",
  d: "M114.941 273.303a41.685 41.685 0 1041.685 41.684 41.732 41.732 0 00-41.685-41.684z",
  fill: "#465a61"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 14",
  d: "M114.941 336.224a21.235 21.235 0 1121.236-21.236 21.26 21.26 0 01-21.236 21.236z",
  fill: "#f0f0f7"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 15",
  d: "M298.669 273.303a41.685 41.685 0 1041.685 41.684 41.732 41.732 0 00-41.685-41.684z",
  fill: "#2f4247"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 16",
  d: "M298.669 336.224a21.235 21.235 0 1121.236-21.236 21.26 21.26 0 01-21.236 21.236z",
  fill: "#e6e7f5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 17",
  d: "M63.346 264.652a10.228 10.228 0 01-10.225 10.225h-21.13v-20.45h21.131a10.228 10.228 0 0110.224 10.225z",
  fill: "#ed6c7b"
}))));
export default SvgBundled;